import { createSlice } from '@reduxjs/toolkit';
import { forgotPassword } from '../../reducers/account/accountThunks';
import { handleRequestThunk } from '../handleRequestThunk';
const SLICE_NAME = 'forgotPassword';

export const forgotPasswordSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        data: {},
        isLoading: false,
        error: null,
    },
    extraReducers: builder => {
        handleRequestThunk({ builder, request: forgotPassword });
    },
});

export const selectForgotPasswordAccountData = state =>
    state.forgotPassword.data;
export const selectForgotPasswordAuthError = state =>
    state.forgotPassword.error;
export const selectForgotPasswordAuthLoading = state =>
    state.forgotPassword.isLoading;

export const forgotPasswordReducer = forgotPasswordSlice.reducer;
